import featureDetection from '@everberg/lib/feature-detection';
import cover from '@everberg/lib/cover';
import security from '@everberg/lib/security';

import scrollAnimate from './components/scroll-animate';
import youtubeBackground from './components/youtube-background';
import cookiebotPlaceholder from './components/cookiebot-placeholder';
import cookieBotSettings from './components/cookiebot-settings';
import searchHighlight from './components/search-highlight';

import '../scss/frontend.scss';

(function () {
	let isInitialized = false;

	window.addEventListener('DOMContentLoaded', () => {
		if (!isInitialized) {
			isInitialized = true;
			init();
		}
	});

	const init = () => {
		featureDetection();
		cover();
		security();

		scrollAnimate();
		youtubeBackground();
		cookieBotSettings();
		cookiebotPlaceholder();
		searchHighlight();
	};
})();
